import { useAppSelector } from "../store";
import { selectBusinessSettings } from "../store/entities/bussinesSettings";

export const useBusinessSettings = () => {
    return useAppSelector(selectBusinessSettings);
}